var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g3, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMsDale = function SvgMsDale(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 253,
    viewBox: "0 0 250 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_4304)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_4304",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 54,
    width: 260,
    height: 188
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.301 54.7828H0.350281V241.986H259.301V54.7828Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_4304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.048 262.738C182.029 262.738 226.599 218.06 226.599 162.947C226.599 107.835 182.029 63.1568 127.048 63.1568C72.0679 63.1568 27.4974 107.835 27.4974 162.947C27.4974 218.06 72.0679 262.738 127.048 262.738Z",
    fill: "#D5F1F7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.663 61.1975C111.663 61.1975 108.122 61.2615 106.462 56.8246C104.802 52.3877 111.773 48.1733 113.542 47.6186C115.311 47.064 122.394 45.1869 121.841 55.4442L111.663 61.1975Z",
    fill: "white",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.649 47.0732C116.649 47.0732 133.493 22.2802 108.802 9.86842C102.704 6.80281 95.618 7.53417 89.3009 10.1213C83.4853 12.5013 78.6457 18.8154 78.67 29.4566C78.7156 50.7391 106.605 52.9728 106.605 52.9728C106.605 52.9728 110.739 47.7619 116.649 47.0732Z",
    fill: "#030038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.099 57.6596C117.099 57.6596 110.228 57.559 111.563 49.4623C111.563 49.4623 106.507 52.0281 106.027 55.8952C106.027 55.8952 107.583 60.7313 111.663 61.1975L117.099 57.6596Z",
    fill: "#E8E9EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.461 149.484L138.205 112.213L116.235 109.583L106.507 149.484C106.507 149.484 107.477 157.414 121.932 156.478C136.384 155.546 138.938 156.475 141.461 149.484Z",
    fill: "white",
    stroke: "#030038",
    strokeWidth: 1.15492,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.801 110.823L113.238 95.0563C113.238 95.0563 107.343 93.4716 108.593 81.8461C109.842 70.2206 125.009 58.4122 139.464 63.0655C153.919 67.7157 150.171 77.912 150.171 77.912C150.171 77.912 154.63 90.0769 149.815 100.986C144.997 111.899 135.95 113.328 131.906 113.151",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.801 110.823L113.238 95.0563C113.238 95.0563 107.343 93.4716 108.593 81.8461C109.842 70.2206 125.009 58.4122 139.464 63.0655C153.919 67.7157 150.171 77.912 150.171 77.912C150.171 77.912 154.63 90.0769 149.815 100.986C144.997 111.899 135.95 113.328 131.906 113.151",
    stroke: "#030038",
    strokeWidth: 1.15492,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.237 77.8328C147.237 77.8328 147.109 79.2955 144.191 78.2685C141.273 77.2446 136.248 74.5782 132.168 76.6199C128.085 78.6586 127.805 82.7146 126.769 85.8015C125.732 88.8884 122.589 91.0825 120.75 89.6655C118.91 88.2485 118.129 83.836 114.98 85.0671C112.754 85.9356 112.718 92.4934 113.578 94.7423C113.578 94.7423 109.015 89.8941 108.854 89.0987C108.693 88.3003 107.133 85.1463 109.368 83.0833C111.602 81.0203 115.396 79.4814 115.396 79.4814C115.396 79.4814 118.351 81.005 118.667 79.0456C118.98 77.0862 118.98 77.0862 118.98 77.0862L122.911 74.115C122.911 74.115 123.255 70.0469 126.769 69.474C130.283 68.9041 134.621 66.9416 134.621 66.9416H142.212C142.212 66.9416 141.273 67.222 143.471 68.5354C145.669 69.8488 145.669 69.8488 145.669 69.8488L147.237 77.8328Z",
    fill: "#E8E9EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.767 95.6962C114.767 95.6962 109.866 94.8064 107.936 92.9719C106.006 91.1374 99.7068 83.2966 103.06 71.79C106.413 60.2833 114.743 55.8007 123.072 53.2561C131.402 50.7116 143.37 55.1089 148.356 62.7821C151.572 67.7309 152.05 75.7454 150.821 77.0771C148.164 79.9507 144.623 78.299 142.999 75.6509C141.376 73.0028 124.495 71.5888 124.696 83.0955C124.696 83.0955 125.085 88.2881 121.944 88.2881C118.804 88.2881 120.327 81.6694 115.959 82.8913C111.593 84.1133 109.04 90.8052 114.767 95.6962Z",
    fill: "#030038"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.238 94.3828C113.238 94.3828 116.171 98.0944 119.479 93.9105",
    stroke: "#030038",
    strokeWidth: 0.632372,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.36 92.8043C116.36 92.8043 121.765 96.3575 119.953 101.251C118.141 106.145 106.802 105.752 111.684 93.9105",
    stroke: "#030038",
    strokeWidth: 1.15492,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.593 92.2771C148.593 92.2771 149.374 88.7666 146.061 88.1693C142.747 87.572 142.647 91.3294 142.647 91.3294",
    stroke: "#030038",
    strokeWidth: 0.962435,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.516 90.1927L140.306 99.295L136.19 98.3687",
    stroke: "#030038",
    strokeWidth: 0.962435,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.454 90.6865C136.454 90.6865 137.321 86.9931 133.94 86.2313C130.56 85.4695 129.909 89.3883 129.909 89.3883",
    stroke: "#030038",
    strokeWidth: 0.962435,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.171 87.1271C150.171 87.1271 149.222 84.4729 146.036 84.4729",
    stroke: "#030038",
    strokeWidth: 0.962435,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.552 82.9949C136.552 82.9949 133.56 81.4957 131.39 83.6745",
    stroke: "#030038",
    strokeWidth: 0.962435,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131.098 97.9543C131.098 97.9543 129.563 106.021 138.245 104.543",
    stroke: "#030038",
    strokeWidth: 0.962435,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.025 112.536C116.025 112.536 116.165 114.91 108.69 134.162C102.89 145.438 104.598 150.645 104.598 150.645C104.598 150.645 105.58 153.751 111.496 152.751L120.549 140.08C123.106 136.222 125.878 123.878 122.227 121.044L116.025 112.536Z",
    fill: "#E8E9EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9972 237.275C52.9972 237.275 38.545 228.288 35.9063 206.597C33.8452 189.651 37.2439 161.406 56.8276 143.804C64.7438 136.689 74.7393 132.316 85.2972 131.045L90.7905 130.384C90.7905 130.384 96.8735 143.64 109.666 145.758C122.458 147.875 138.047 146.958 144.118 129.765C144.118 129.765 178.23 143.298 196.522 181.692C214.813 220.085 196.522 241.386 196.522 241.386H68.0999C68.0999 241.392 56.3138 241.669 52.9972 237.275Z",
    fill: "white",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5507 238.488C54.5507 238.488 40.0985 229.501 37.4598 207.81C35.3987 190.864 38.7974 162.618 58.3811 145.017C66.2972 137.902 76.2927 133.529 86.8507 132.258L92.3439 131.597C92.3439 131.597 98.427 144.853 111.219 146.97C124.012 149.088 138.12 148.299 144.647 133.535C144.647 133.535 173.637 146.76 191.928 185.153C210.22 223.547 198.075 242.598 198.075 242.598H69.6534C69.6534 242.604 57.8673 242.882 54.5507 238.488Z",
    fill: "#80D6E7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9751 209.73C47.9751 209.73 41.582 180.582 62.9805 145.846L58.2229 141.756C58.2229 141.756 39.3506 155.89 36.1981 191.467C36.1981 191.467 31.778 218.159 47.6285 232.445C47.6285 232.448 42.8436 224.887 47.9751 209.73Z",
    fill: "#2CBAD8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_4304",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 130,
    width: 165,
    height: 112
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9972 237.275C52.9972 237.275 39.4601 229.221 36.8213 207.53C34.7602 190.584 38.1833 161.652 57.767 144.051C65.6831 136.936 74.7393 132.316 85.2972 131.045L90.7905 130.384C90.7905 130.384 96.4266 141.595 108.565 146.157C116.81 149.256 138.996 150.749 144.644 133.535C144.644 133.535 172.08 145.547 190.372 183.941C208.663 222.334 196.519 241.386 196.519 241.386H68.0999C68.0999 241.392 56.3138 241.669 52.9972 237.275Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_4304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7532 232.207C84.7532 244.058 75.168 253.666 63.3455 253.666C51.5229 253.666 41.9378 244.058 41.9378 232.207C41.9378 220.356 51.5229 210.748 63.3455 210.748C75.168 210.748 84.7532 220.356 84.7532 232.207ZM27.1573 232.207C27.1573 252.243 43.3605 268.482 63.3455 268.482C83.3304 268.482 99.5336 252.24 99.5336 232.207C99.5336 212.174 83.3304 195.932 63.3455 195.932C43.3605 195.929 27.1573 212.171 27.1573 232.207Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3455 223.01C68.4132 223.01 72.5202 227.127 72.5202 232.207C72.5202 237.287 68.4132 241.404 63.3455 241.404C58.2778 241.404 54.1708 237.287 54.1708 232.207C54.1708 227.127 58.2809 223.01 63.3455 223.01Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.104 236.784C170.104 246.883 161.939 255.068 151.864 255.068C141.79 255.068 133.624 246.883 133.624 236.784C133.624 226.685 141.79 218.5 151.864 218.5C161.936 218.5 170.104 226.685 170.104 236.784ZM121.03 236.784C121.03 253.855 134.834 267.693 151.864 267.693C168.894 267.693 182.699 253.855 182.699 236.784C182.699 219.713 168.894 205.875 151.864 205.875C134.834 205.875 121.03 219.713 121.03 236.784Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.864 228.946C156.181 228.946 159.68 232.454 159.68 236.784C159.68 241.111 156.181 244.619 151.864 244.619C147.548 244.619 144.049 241.111 144.049 236.784C144.045 232.457 147.545 228.946 151.864 228.946Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.79 182.335C126.79 190.124 120.491 196.438 112.721 196.438C104.951 196.438 98.652 190.124 98.652 182.335C98.652 174.546 104.951 168.232 112.721 168.232C120.491 168.232 126.79 174.546 126.79 182.335ZM88.9362 182.335C88.9362 195.502 99.5853 206.177 112.721 206.177C125.857 206.177 136.506 195.502 136.506 182.335C136.506 169.167 125.857 158.492 112.721 158.492C99.5853 158.495 88.9362 169.167 88.9362 182.335Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.721 176.292C116.05 176.292 118.75 178.998 118.75 182.335C118.75 185.671 116.05 188.377 112.721 188.377C109.392 188.377 106.693 185.671 106.693 182.335C106.693 178.998 109.389 176.292 112.721 176.292Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.105 147.802C176.105 155.396 169.964 161.555 162.386 161.555C154.81 161.555 148.666 155.399 148.666 147.802C148.666 140.208 154.807 134.05 162.386 134.05C169.964 134.05 176.105 140.205 176.105 147.802Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.386 141.909C165.632 141.909 168.265 144.548 168.265 147.802C168.265 151.057 165.632 153.696 162.386 153.696C159.139 153.696 156.506 151.057 156.506 147.802C156.506 144.548 159.139 141.909 162.386 141.909Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7731 148.177C76.7731 155.771 70.6323 161.93 63.0536 161.93C55.4779 161.93 49.3341 155.774 49.3341 148.177C49.3341 140.58 55.4749 134.425 63.0536 134.425C70.6293 134.428 76.7731 140.583 76.7731 148.177ZM39.8645 148.177C39.8645 161.015 50.2461 171.422 63.0536 171.422C75.8611 171.422 86.2427 161.015 86.2427 148.177C86.2427 135.339 75.8611 124.932 63.0536 124.932C50.2461 124.932 39.8645 135.339 39.8645 148.177Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0536 142.284C66.3004 142.284 68.933 144.923 68.933 148.177C68.933 151.432 66.3004 154.071 63.0536 154.071C59.8069 154.071 57.1743 151.432 57.1743 148.177C57.1743 144.923 59.8069 142.284 63.0536 142.284Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9972 237.275C52.9972 237.275 39.4601 229.221 36.8213 207.53C34.7602 190.584 38.1833 161.652 57.767 144.051C65.6831 136.936 74.7393 132.316 85.2972 131.045L90.7905 130.384C90.7905 130.384 96.4266 141.595 108.565 146.157C116.81 149.256 138.996 150.749 144.644 133.535C144.644 133.535 172.08 145.547 190.372 183.941C208.663 222.334 196.519 241.386 196.519 241.386H68.0999C68.0999 241.392 56.3138 241.669 52.9972 237.275Z",
    stroke: "#2CBAD8",
    strokeWidth: 0.700844,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.118 129.415L139.95 128.641L140.649 136.649L142.665 133.23L144.118 129.415Z",
    fill: "#030038"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9203 241.376L100.99 241.416C100.99 241.416 119.391 233.197 120.017 209.474C120.643 185.751 103.586 165.132 103.586 165.132C103.586 165.132 112.815 182.725 112.946 191.455C113.077 200.186 113.609 214.389 101.066 231.311C101.066 231.314 93.8851 239.387 85.9203 241.376Z",
    fill: "#2CBAD8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166.137 155.271C166.137 155.271 163.653 157.432 165.45 160.735L168.323 161.381C168.323 161.381 166.201 160.525 165.824 158.328C165.447 156.128 166.137 155.271 166.137 155.271Z",
    fill: "#E8E9EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M161.109 161.381C161.109 161.381 157.759 164.099 161.519 170.816C161.519 170.816 161.61 169.368 163.465 168.686C163.465 168.686 159.406 166.552 161.109 161.381Z",
    fill: "#E8E9EF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.985 177.288C163.985 177.288 158.294 175.378 160.504 168.695L161.519 170.816C161.519 170.816 161.09 172.641 162.005 174.433C163.589 177.526 163.985 177.288 163.985 177.288Z",
    fill: "#E8E9EF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M139.826 137.143L130.994 113.651C130.994 113.651 135.74 113.895 137.716 112.956",
    fill: "#E8E9EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.997 237.884C52.997 237.884 38.5449 228.898 35.9062 207.207C33.845 190.261 37.2438 162.015 56.8274 144.414C64.7436 137.298 74.7391 132.925 85.297 131.655L90.7903 130.993C90.7903 130.993 96.8734 144.249 109.666 146.367C122.458 148.485 138.047 147.568 144.118 130.375C144.118 130.375 178.23 143.908 196.522 182.301C214.813 220.694 196.522 241.995 196.522 241.995H68.0998C68.0998 242.001 56.3137 242.278 52.997 237.884Z",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.748 179.348L137.932 176.834C137.932 176.834 136.676 176.993 134.481 175.89L131.657 173.217C131.657 173.217 130.401 171.486 131.657 168.186L159.111 106.7C159.111 106.7 160.838 101.038 167.897 101.352L199.273 103.083C199.273 103.083 206.696 103.293 202.985 112.859L184.684 158.995C184.684 158.995 178.175 176.484 175.527 178.528C172.879 180.573 168.748 179.348 168.748 179.348Z",
    fill: "white",
    stroke: "#030038",
    strokeWidth: 1.27627,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M134.481 175.889L162.194 111.329C162.194 111.329 164.343 105.524 169.809 105.524L199.042 106.993C199.042 106.993 205.149 107.611 202.231 114.967",
    stroke: "#030038",
    strokeWidth: 0.698812,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M176.074 105.877C176.074 105.877 185.523 113.947 185.897 124.938C186.271 135.93 179.087 169.792 166.006 177.556C166.006 177.556 167.584 178.775 172.949 177.73C178.315 176.685 192.101 138.38 192.101 138.38C192.101 138.38 201.653 114.303 201.939 113.581C202.225 112.859 204.173 108.379 198.282 106.996L176.074 105.877Z",
    fill: "#E8E9EF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M134.481 175.889L162.194 111.329C162.194 111.329 164.343 105.524 169.809 105.524L199.042 106.993C199.042 106.993 205.149 107.611 202.231 114.967",
    stroke: "#030038",
    strokeWidth: 0.698812,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M198.184 167.814C198.4 167.348 218.616 209.666 217.209 220.755C215.801 231.844 209.767 242.446 194.478 241.986C179.19 241.526 175.971 232.856 175.77 223.175C175.57 213.496 179.622 183.197 179.622 183.197C179.622 183.197 192.235 180.61 198.184 167.814Z",
    fill: "white",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184.635 181.628C184.635 181.628 183.243 215.285 189.946 227.136C196.652 238.987 202.562 239.908 207.9 238.475C207.9 238.475 200.021 243.662 190.131 241.59C180.242 239.518 175.065 233.85 175.761 222.361C176.458 210.873 179.619 183.197 179.619 183.197L184.635 181.628Z",
    fill: "#E8E9EF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M191.518 142.707C191.518 142.707 191.153 147.869 194.36 152.641C197.567 157.413 200.869 163.743 196.984 170.56C193.098 177.376 187.462 182.246 177.746 183.124C168.031 184.001 162.495 176.697 162.008 175.039C161.522 173.384 160.552 170.267 163.464 169.292C163.464 169.292 158.473 165.202 161.455 161.5C161.455 161.5 162.592 160.235 164.826 161.11C167.061 161.988 168.325 161.988 168.325 161.988C168.325 161.988 164.732 159.943 165.896 156.435C167.064 152.928 171.63 156.143 172.989 157.215C174.348 158.288 177.166 160.915 181.732 158.87C186.298 156.825 191.518 142.707 191.518 142.707Z",
    fill: "white",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M162.045 167.811C162.045 167.811 164.766 171.961 172.615 172.556Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.045 167.811C162.045 167.811 164.766 171.961 172.615 172.556",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M167.781 161.619C167.781 161.619 170.086 163.185 174.956 164.133Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M167.781 161.619C167.781 161.619 170.086 163.185 174.956 164.133",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M161.519 171.425C161.519 171.425 169.113 181.67 178.111 180.186C187.113 178.702 195.278 173.445 198.498 161.619C198.498 161.619 199.589 169.383 194.543 174.244C189.496 179.107 187.025 181.816 176.503 183.194C176.503 183.194 172.098 184.273 163.985 177.895C163.985 177.898 161.437 176.554 161.519 171.425Z",
    fill: "#E8E9EF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M162.68 160.872C162.68 160.872 166.587 165.416 174.956 164.136L168.976 162.265L162.68 160.872Z",
    fill: "#E8E9EF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.68 169.688C162.68 169.688 165.252 174.826 172.615 172.9C172.615 172.9 168.155 171.922 166.167 170.871C164.182 169.819 163.462 169.295 163.462 169.295L162.68 169.688Z",
    fill: "#E8E9EF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M191.518 142.707C191.518 142.707 191.153 147.869 194.36 152.641C197.567 157.413 200.869 163.743 196.984 170.56C193.098 177.376 187.462 182.246 177.746 183.124C168.031 184.001 162.495 176.697 162.008 175.039C161.522 173.384 160.552 170.267 163.464 169.292C163.464 169.292 158.473 165.202 161.455 161.5C161.455 161.5 162.592 160.235 164.826 161.11C167.061 161.988 168.325 161.988 168.325 161.988C168.325 161.988 164.732 159.943 165.896 156.435C167.064 152.928 171.63 156.143 172.989 157.215C174.348 158.288 177.166 160.915 181.732 158.87C186.298 156.825 191.518 142.707 191.518 142.707Z",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M162.045 167.811C162.045 167.811 164.766 171.961 172.615 172.556",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M167.781 161.619C167.781 161.619 170.086 163.185 174.956 164.133",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M198.184 167.814C198.4 167.348 218.616 209.666 217.209 220.755C215.801 231.844 209.767 242.446 194.479 241.986C179.19 241.526 175.971 232.856 175.77 223.175C175.57 213.496 179.622 183.197 179.622 183.197C179.622 183.197 193.618 181.628 198.184 167.814Z",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6876 168.707L14.3769 120.718C8.9231 116.448 7.95334 108.553 12.2124 103.086L36.9914 71.278C41.0833 66.0244 48.6498 65.0919 53.8908 69.1936L115.974 117.789C121.215 121.891 122.145 129.476 118.053 134.729L93.274 166.537C89.0149 172.007 81.1413 172.976 75.6876 168.707Z",
    stroke: "#020030",
    strokeWidth: 0.382731,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0068 168.96L14.0577 120.468C8.78021 116.335 7.84389 108.699 11.9631 103.409L36.9397 71.3448C41.062 66.0546 48.6802 65.1161 53.9577 69.2452L115.91 117.737C121.187 121.869 122.124 129.506 118.004 134.796L93.0277 166.86C88.9055 172.15 81.2842 173.089 76.0068 168.96Z",
    fill: "white",
    stroke: "#020030",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3_4304",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 66,
    width: 100,
    height: 89
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M102.224 154.854L21.001 91.2775L36.2223 71.7381C40.6181 66.0945 48.7471 65.0919 54.3772 69.4983L115.208 117.116C120.838 121.522 122.719 129.272 117.442 135.314L102.224 154.854Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3_4304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4552 151.045C50.7077 152.023 50.9296 153.836 49.9507 155.091C48.9749 156.347 47.1661 156.569 45.9136 155.588C44.6611 154.61 44.4392 152.797 45.4181 151.541C46.397 150.286 48.2058 150.063 49.4552 151.045Z",
    fill: "#020030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5576 170.605C42.2626 169.591 42.0346 167.707 43.0499 166.403C44.0653 165.099 45.944 164.864 47.2391 165.879C48.5341 166.894 48.7621 168.777 47.7467 170.081C46.7314 171.382 44.8527 171.617 43.5576 170.605ZM47.1387 166.007C45.9136 165.05 44.1383 165.273 43.1776 166.504C42.217 167.735 42.4328 169.517 43.6579 170.474C44.8831 171.431 46.6584 171.209 47.6191 169.978C48.5767 168.747 48.3608 166.967 47.1387 166.007ZM41.8461 160.857C40.5511 159.842 40.3231 157.959 41.3384 156.655C42.3538 155.354 44.2325 155.116 45.5275 156.131C46.8226 157.145 47.0506 159.029 46.0352 160.333C45.0229 161.637 43.1411 161.872 41.8461 160.857ZM45.4272 156.262C44.2021 155.305 42.4267 155.527 41.4661 156.758C40.5055 157.989 40.7213 159.772 41.9464 160.729C43.1715 161.686 44.9469 161.463 45.9075 160.232C46.8682 159.001 46.6523 157.222 45.4272 156.262ZM51.6927 160.159C50.3976 159.144 50.1696 157.261 51.185 155.957C52.2003 154.653 54.0791 154.418 55.3741 155.433C56.6691 156.448 56.8971 158.331 55.8818 159.635C54.8695 160.936 52.9877 161.171 51.6927 160.159ZM55.2738 155.564C54.0487 154.607 52.2733 154.829 51.3127 156.061C50.352 157.292 50.5679 159.074 51.793 160.031C53.0181 160.988 54.7935 160.766 55.7541 159.534C56.7147 158.303 56.4989 156.521 55.2738 155.564Z",
    fill: "#020030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7155 125.433L35.0215 132.742L42.2029 138.364L47.8969 131.055L40.7155 125.433Z",
    stroke: "#FDFCFF",
    strokeWidth: 0.704033,
    strokeMiterlimit: 10.0005
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7016 127.986C70.562 129.442 70.8904 132.13 69.4403 133.995C67.9872 135.86 65.3028 136.189 63.4454 134.735C61.5849 133.279 61.2566 130.588 62.7067 128.726C64.1568 126.864 66.8411 126.532 68.7016 127.986Z",
    fill: "#020030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.337 154.12L105.474 189.886L140.615 217.394L168.478 181.628L133.337 154.12Z",
    stroke: "#020030",
    strokeWidth: 0.704033,
    strokeMiterlimit: 10.0005
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.197 163.341L82.4393 146.346L86.1541 176.615L69.197 163.341Z",
    stroke: "#020030",
    strokeWidth: 0.648281,
    strokeMiterlimit: 10
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.001 91.2775L102.224 154.854",
    stroke: "#020030",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3049 97.4606L31.3766 91.2563C30.5832 90.6346 30.4403 89.4827 31.0604 88.6874L35.1462 83.4429C35.7664 82.6476 36.9155 82.5043 37.7089 83.126L45.6372 89.3303C46.4307 89.952 46.5736 91.1039 45.9534 91.8992L41.8676 97.1437C41.2444 97.9421 40.0984 98.0853 39.3049 97.4606Z",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4228 84.3021L37.7242 86.8832",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0547 86.0575L36.3562 88.6416",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7232 87.77L35.0216 90.3541",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9042 90.1561L45.2026 92.7402",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5362 91.9114L43.8346 94.4955",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2016 93.624L42.5031 96.2081",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2923 93.8981L35.5566 93.3222C34.5869 92.5634 34.4136 91.1586 35.1706 90.1865L37.5934 87.0782C38.3504 86.1061 39.7518 85.9324 40.7216 86.6912L41.4573 87.2672C42.427 88.026 42.6003 89.4308 41.8434 90.4029L39.4205 93.5111C38.6635 94.4832 37.2621 94.6569 36.2923 93.8981Z",
    stroke: "#020030",
    strokeWidth: 0.374111,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1269 233.493C44.8194 228.855 42.4543 210.038 57.6786 201.106C57.6786 201.106 68.0663 209.148 76.6725 197.577C76.6725 197.577 81.7098 192.948 82.9684 186.427C82.9684 186.427 73.1036 180.747 71.006 171.91C68.9084 163.072 76.0432 149.238 76.0432 149.238C76.0432 149.238 79.0711 141.016 83.3453 135.704C83.3453 135.704 85.4004 131.834 89.7597 134.12C94.3136 136.509 89.7597 149.308 89.7597 149.308C89.7597 149.308 95.2196 149.253 96.4143 153.443C96.4143 153.443 103.628 151.048 105.881 157.313C108.133 163.578 103.583 165.742 103.583 165.742C103.583 165.742 108.501 176.938 109.602 179.561C109.602 179.561 119.102 197.117 107.27 221.873C95.4385 246.63 79.442 241.556 70.553 241.66C63.1324 241.751 54.2008 242.004 48.1269 233.493Z",
    fill: "white",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1856 135.531C91.1856 135.531 86.2091 135.564 82.0808 146.891C77.9525 158.218 73.8363 170.843 83.6434 178.196C93.4504 185.549 88.7262 196.34 84.3912 200.896C80.0561 205.451 73.0946 218.186 51.3434 206.424L57.6848 201.106C57.6848 201.106 67.1787 207.844 73.2648 201.149C79.3509 194.454 82.5429 192.339 82.9745 186.427C82.9745 186.427 73.207 179.848 71.0122 171.91C68.8173 163.971 73.5931 152.903 82.0838 137.259C82.0808 137.259 84.5979 130.088 91.1856 135.531Z",
    fill: "#E8E9EF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0254 153.281C97.0254 153.281 93.4534 151.901 91.1886 154.948C88.9208 157.996 91.2798 163.475 91.2798 163.475C91.2798 163.475 90.7174 156.222 97.0254 153.281Z",
    fill: "#E8E9EF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7629 149.308C89.7629 149.308 82.02 151.852 82.0808 159.647C82.0808 159.647 79.9102 154.555 83.467 150.807C86.504 147.607 89.7629 149.308 89.7629 149.308Z",
    fill: "#E8E9EF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0254 153.281C97.0254 153.281 90.3405 155.509 91.2768 163.475",
    stroke: "#030038",
    strokeWidth: 0.575604,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7629 149.308C89.7629 149.308 82.0808 151.557 82.0808 159.647",
    stroke: "#030038",
    strokeWidth: 0.575604,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1269 233.493C44.8194 228.855 42.4543 210.038 57.6786 201.106C57.6786 201.106 68.0663 209.148 76.6725 197.577C76.6725 197.577 81.7098 192.948 82.9684 186.427C82.9684 186.427 73.1036 180.747 71.006 171.91C68.9084 163.072 76.0432 149.238 76.0432 149.238C76.0432 149.238 79.0711 141.016 83.3453 135.704C83.3453 135.704 85.4004 131.834 89.7597 134.12C94.3136 136.509 89.7597 149.308 89.7597 149.308C89.7597 149.308 95.2196 149.253 96.4143 153.443C96.4143 153.443 103.628 151.048 105.881 157.313C108.133 163.578 103.583 165.742 103.583 165.742C103.583 165.742 108.501 176.938 109.602 179.561C109.602 179.561 119.102 197.117 107.27 221.873C95.4385 246.63 79.442 241.556 70.553 241.66C63.1324 241.751 54.2008 242.004 48.1269 233.493Z",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M111.663 61.8068C111.663 61.8068 108.121 61.8708 106.461 57.4339C104.802 52.997 111.772 48.7826 113.542 48.228C115.311 47.6734 122.394 45.7962 121.841 56.0535L111.663 61.8068Z",
    stroke: "#030038",
    strokeWidth: 1.05127,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_4304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 252.778,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMsDale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ms_dale.477aecc6a8647bcc1b9a7a4637384659.svg";